
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-board/[platform]",
      function () {
        return require("private-next-pages/job-board/[platform].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-board/[platform]"])
      });
    }
  